
import './App.css';
// import About from './components/About';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';
import React, { useState } from 'react';
import Alert from './components/Alert';
import FootNote from './components/FootNote';
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route
// } from "react-router-dom";

function App() {
  //lec 12
  const [mode, setmode] = useState('light');
  //lec 13

   
  const [alert, setalert] = useState(null);

  const showAlert=(message, type)=>{
    setalert({
      msg: message,
      type: type
    })
    setTimeout(() => {
      setalert(null);
    }, 2000);
  }

  const toggleMode=()=>{
    if(mode === 'light'){
      setmode('dark');
      document.body.style.backgroundColor = '#04274b';
      showAlert("Dark mode has been enabled", "success");
    }
    else{
      setmode('light');
      document.body.style.backgroundColor = 'white';
      showAlert("Light mode has been enabled", "success");
    }
  }

  return (
   <>
   {/* <Router> */}
      <Navbar title="Abhishek's Editor" mode={mode} toggleMode={toggleMode} />
      <Alert alert={alert}/>
      <div className="container my-3">
      {/* <About/> */}
      <TextForm hh={showAlert} heading = "Enter the text to analyse below"  mode={mode} />
        {/* <Routes>
          <Route exact path="/about" element={<About/>}></Route>
          <Route exact path="/" element={<TextForm hh={showAlert} heading = "Enter the text to analyse below"  mode={mode} />}></Route>
        </Routes> */}
      </div> 
      <FootNote/>
      {/* </Router> */}
   </>
  );
}

export default App;
